var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRevenue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 59,
    viewBox: "0 0 62 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 61.2264,
    height: 59,
    rx: 8,
    fill: "#FFEECC",
    fillOpacity: 0.958352
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1948_4298)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.011 31.492C37.011 32.482 36.75 33.4 36.228 34.246C35.724 35.074 34.968 35.758 33.96 36.298C32.97 36.82 31.791 37.108 30.423 37.162V39.349H28.695V37.135C26.787 36.973 25.248 36.406 24.078 35.434C22.908 34.444 22.287 33.103 22.215 31.411H27.129C27.237 32.491 27.759 33.184 28.695 33.49V29.224C27.291 28.864 26.166 28.513 25.32 28.171C24.492 27.829 23.763 27.28 23.133 26.524C22.503 25.768 22.188 24.733 22.188 23.419C22.188 21.781 22.791 20.467 23.997 19.477C25.221 18.487 26.787 17.929 28.695 17.803V15.616H30.423V17.803C32.313 17.947 33.807 18.496 34.905 19.45C36.003 20.404 36.615 21.727 36.741 23.419H31.8C31.692 22.447 31.233 21.817 30.423 21.529V25.714C31.917 26.128 33.069 26.497 33.879 26.821C34.689 27.145 35.409 27.685 36.039 28.441C36.687 29.179 37.011 30.196 37.011 31.492ZM27.075 23.203C27.075 23.653 27.21 24.031 27.48 24.337C27.768 24.643 28.173 24.913 28.695 25.147V21.394C28.191 21.484 27.795 21.682 27.507 21.988C27.219 22.276 27.075 22.681 27.075 23.203ZM30.423 33.571C30.963 33.481 31.386 33.265 31.692 32.923C32.016 32.581 32.178 32.158 32.178 31.654C32.178 31.186 32.025 30.808 31.719 30.52C31.431 30.214 30.999 29.953 30.423 29.737V33.571Z",
    fill: "#A77C27"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1948_4298"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 44,
    fill: "white",
    transform: "translate(13 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevenue);
export default __webpack_public_path__ + "static/media/revenue.d582015249de22c1f41e0dda38c3a0a0.svg";
export { ForwardRef as ReactComponent };